import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { TextTooltip } from 'components/Tooltip'
import { IconLock } from 'icons'

import { IPhoneNumberProps } from './types'

const PhoneNumber = ({ phone }: IPhoneNumberProps) => {
  const { t } = useTranslation(['crm'])
  const isPhoneRestricted = useMemo(() => phone === 'restricted', [phone])

  if (!phone?.length) {
    return null
  }

  return (
    <div className="mb-4 flex   text-2xl  font-light md:mb-0 md:text-lg">
      <TextTooltip
        disabled={!isPhoneRestricted}
        tooltipContent={t('org.restrictions.phone.tooltip', { ns: 'crm' })}
        className="flex items-center gap-x-1"
      >
        <>
          {isPhoneRestricted
            ? t('org.restrictions.phone.placeholder', { ns: 'crm' })
            : phone}

          {isPhoneRestricted && <IconLock size={18} />}
        </>
      </TextTooltip>
    </div>
  )
}

export default PhoneNumber
